var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyInit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.75C20.7648 1.75 26.25 7.23516 26.25 14C26.25 20.7648 20.7648 26.25 14 26.25C7.23516 26.25 1.75 20.7648 1.75 14C1.75 7.23516 7.23516 1.75 14 1.75ZM8.75 14.6562C8.75 14.7766 8.84844 14.875 8.96875 14.875H13.125V19.0312C13.125 19.1516 13.2234 19.25 13.3438 19.25H14.6562C14.7766 19.25 14.875 19.1516 14.875 19.0312V14.875H19.0312C19.1516 14.875 19.25 14.7766 19.25 14.6562V13.3438C19.25 13.2234 19.1516 13.125 19.0312 13.125H14.875V8.96875C14.875 8.84844 14.7766 8.75 14.6562 8.75H13.3438C13.2234 8.75 13.125 8.84844 13.125 8.96875V13.125H8.96875C8.84844 13.125 8.75 13.2234 8.75 13.3438V14.6562Z",
    fill: "#696969"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyInit);
export default __webpack_public_path__ + "static/media/grey-init.2ec33c7931a3a3efc5bd32ee5920ea9a.svg";
export { ForwardRef as ReactComponent };